import React, { FC } from 'react'
import { BackgroundTheme, BannerAd } from 'advertising/BannerAd/BannerAd'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { Breakpoint, useCurrentBreakpoint } from 'hooks/CurrentBreakpoint'
import { getChannelAdTargeting } from 'pages/ChannelPage/Start/getChannelAdTargeting'

export interface Props {
  showOnlySmallAdSizes?: boolean
  backgroundTheme?: BackgroundTheme
  hidePadding?: boolean
}

export const BannerAdSection: FC<Props> = ({
  showOnlySmallAdSizes,
  backgroundTheme = BackgroundTheme.LightGrey,
  hidePadding = false
}) => {
  const channel = useSelector(channelSelector)
  const { parentChannelDomain, partnerDomain, sportCategory, countryCode } =
    getChannelAdTargeting(channel?.data)
  const targetingOptions = {
    partnerDomain: partnerDomain,
    parentChannelDomain: parentChannelDomain,
    sportCategory: sportCategory,
    countryCode: countryCode
  }
  const currentBreakpoint = useCurrentBreakpoint()
  const isMobile = currentBreakpoint <= Breakpoint.sm
  return (
    <BannerAd
      adId={'div-gpt-ad-1721803826377-0'}
      slotPath={'/21792873324/viewer_page_banner'}
      hidePadding={hidePadding}
      multiSize={
        showOnlySmallAdSizes || isMobile
          ? [
              [320, 100],
              [320, 240],
              [320, 50],
              [320, 320]
            ]
          : [
              [970, 250],
              [970, 90],
              [980, 240],
              [728, 90],
              [980, 90],
              [980, 120]
            ]
      }
      targetingOptions={targetingOptions}
      backgroundTheme={backgroundTheme}
    />
  )
}
